import React from "react";
import { Link } from "react-router-dom";

type CardProps = {
  padding?: string;
  backgroundColor?: string;
  to?: string;
  children?: React.ReactChild;
  className?: string;
  borderRadius: string;
};

const defaultProps = {
  padding: "",
  backgroundColor: "bg-white",
  className: "",
  borderRadius: "rounded-md",
};

const Card = ({
  padding,
  backgroundColor,
  children,
  to,
  className,
  borderRadius,
}: CardProps): JSX.Element => {
  if (!!to) {
    return (
      <Link
        to={to || "#"}
        children={children}
        className={`relative w-full h-full ${backgroundColor} ${padding} ${className} ${borderRadius}`}
      ></Link>
    );
  } else {
    return (
      <div
        children={children}
        className={`relative w-full h-full ${backgroundColor} ${padding} ${className} ${borderRadius}`}
      ></div>
    );
  }
};

Card.defaultProps = defaultProps;

export default Card;
